/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiExcelCheckVoucherGet } from '../fn/excel/api-excel-check-voucher-get';
import { ApiExcelCheckVoucherGet$Params } from '../fn/excel/api-excel-check-voucher-get';
import { apiExcelExcelApplicantPoolGet } from '../fn/excel/api-excel-excel-applicant-pool-get';
import { ApiExcelExcelApplicantPoolGet$Params } from '../fn/excel/api-excel-excel-applicant-pool-get';
import { apiExcelExcelBillingCnxGet } from '../fn/excel/api-excel-excel-billing-cnx-get';
import { ApiExcelExcelBillingCnxGet$Params } from '../fn/excel/api-excel-excel-billing-cnx-get';
import { apiExcelExcelBillingGet } from '../fn/excel/api-excel-excel-billing-get';
import { ApiExcelExcelBillingGet$Params } from '../fn/excel/api-excel-excel-billing-get';
import { apiExcelExcelBillingNoPositionGet } from '../fn/excel/api-excel-excel-billing-no-position-get';
import { ApiExcelExcelBillingNoPositionGet$Params } from '../fn/excel/api-excel-excel-billing-no-position-get';
import { apiExcelExcelBillingRegisterGet } from '../fn/excel/api-excel-excel-billing-register-get';
import { ApiExcelExcelBillingRegisterGet$Params } from '../fn/excel/api-excel-excel-billing-register-get';
import { apiExcelExcelCashReceiptRegisterGet } from '../fn/excel/api-excel-excel-cash-receipt-register-get';
import { ApiExcelExcelCashReceiptRegisterGet$Params } from '../fn/excel/api-excel-excel-cash-receipt-register-get';
import { apiExcelExcelCheckDisbursementsGet } from '../fn/excel/api-excel-excel-check-disbursements-get';
import { ApiExcelExcelCheckDisbursementsGet$Params } from '../fn/excel/api-excel-excel-check-disbursements-get';
import { apiExcelExcelCheckRegisterGet } from '../fn/excel/api-excel-excel-check-register-get';
import { ApiExcelExcelCheckRegisterGet$Params } from '../fn/excel/api-excel-excel-check-register-get';
import { apiExcelExcelCoopShareLedgerGet } from '../fn/excel/api-excel-excel-coop-share-ledger-get';
import { ApiExcelExcelCoopShareLedgerGet$Params } from '../fn/excel/api-excel-excel-coop-share-ledger-get';
import { apiExcelExcelDeductionsLedgerGet } from '../fn/excel/api-excel-excel-deductions-ledger-get';
import { ApiExcelExcelDeductionsLedgerGet$Params } from '../fn/excel/api-excel-excel-deductions-ledger-get';
import { apiExcelExcelEmployeesProfileForm1Get } from '../fn/excel/api-excel-excel-employees-profile-form-1-get';
import { ApiExcelExcelEmployeesProfileForm1Get$Params } from '../fn/excel/api-excel-excel-employees-profile-form-1-get';
import { apiExcelExcelEmployeesProfileForm2Get } from '../fn/excel/api-excel-excel-employees-profile-form-2-get';
import { ApiExcelExcelEmployeesProfileForm2Get$Params } from '../fn/excel/api-excel-excel-employees-profile-form-2-get';
import { apiExcelExcelEvaluationFormGet } from '../fn/excel/api-excel-excel-evaluation-form-get';
import { ApiExcelExcelEvaluationFormGet$Params } from '../fn/excel/api-excel-excel-evaluation-form-get';
import { apiExcelExcelExportDeductionsByClientGet } from '../fn/excel/api-excel-excel-export-deductions-by-client-get';
import { ApiExcelExcelExportDeductionsByClientGet$Params } from '../fn/excel/api-excel-excel-export-deductions-by-client-get';
import { apiExcelExcelExportDeductionsGet } from '../fn/excel/api-excel-excel-export-deductions-get';
import { ApiExcelExcelExportDeductionsGet$Params } from '../fn/excel/api-excel-excel-export-deductions-get';
import { apiExcelExcelExportDisbursementAdviceGet } from '../fn/excel/api-excel-excel-export-disbursement-advice-get';
import { ApiExcelExcelExportDisbursementAdviceGet$Params } from '../fn/excel/api-excel-excel-export-disbursement-advice-get';
import { apiExcelExcelExportMembersGet } from '../fn/excel/api-excel-excel-export-members-get';
import { ApiExcelExcelExportMembersGet$Params } from '../fn/excel/api-excel-excel-export-members-get';
import { apiExcelExcelExportSavingsMasterfileGet } from '../fn/excel/api-excel-excel-export-savings-masterfile-get';
import { ApiExcelExcelExportSavingsMasterfileGet$Params } from '../fn/excel/api-excel-excel-export-savings-masterfile-get';
import { apiExcelExcelExportSingleDeductionReportGet } from '../fn/excel/api-excel-excel-export-single-deduction-report-get';
import { ApiExcelExcelExportSingleDeductionReportGet$Params } from '../fn/excel/api-excel-excel-export-single-deduction-report-get';
import { apiExcelExcelFormAGet } from '../fn/excel/api-excel-excel-form-a-get';
import { ApiExcelExcelFormAGet$Params } from '../fn/excel/api-excel-excel-form-a-get';
import { apiExcelExcelFormBGet } from '../fn/excel/api-excel-excel-form-b-get';
import { ApiExcelExcelFormBGet$Params } from '../fn/excel/api-excel-excel-form-b-get';
import { apiExcelExcelFormCfGet } from '../fn/excel/api-excel-excel-form-cf-get';
import { ApiExcelExcelFormCfGet$Params } from '../fn/excel/api-excel-excel-form-cf-get';
import { apiExcelExcelFormDGet } from '../fn/excel/api-excel-excel-form-d-get';
import { ApiExcelExcelFormDGet$Params } from '../fn/excel/api-excel-excel-form-d-get';
import { apiExcelExcelFormEGet } from '../fn/excel/api-excel-excel-form-e-get';
import { ApiExcelExcelFormEGet$Params } from '../fn/excel/api-excel-excel-form-e-get';
import { apiExcelExcelGenJournalGet } from '../fn/excel/api-excel-excel-gen-journal-get';
import { ApiExcelExcelGenJournalGet$Params } from '../fn/excel/api-excel-excel-gen-journal-get';
import { apiExcelExcelGmd2Get } from '../fn/excel/api-excel-excel-gmd-2-get';
import { ApiExcelExcelGmd2Get$Params } from '../fn/excel/api-excel-excel-gmd-2-get';
import { apiExcelExcelGmdGet } from '../fn/excel/api-excel-excel-gmd-get';
import { ApiExcelExcelGmdGet$Params } from '../fn/excel/api-excel-excel-gmd-get';
import { apiExcelExcelImportSalaryTablePost$Json } from '../fn/excel/api-excel-excel-import-salary-table-post-json';
import { ApiExcelExcelImportSalaryTablePost$Json$Params } from '../fn/excel/api-excel-excel-import-salary-table-post-json';
import { apiExcelExcelImportSalaryTablePost$Plain } from '../fn/excel/api-excel-excel-import-salary-table-post-plain';
import { ApiExcelExcelImportSalaryTablePost$Plain$Params } from '../fn/excel/api-excel-excel-import-salary-table-post-plain';
import { apiExcelExcelIpcrGet } from '../fn/excel/api-excel-excel-ipcr-get';
import { ApiExcelExcelIpcrGet$Params } from '../fn/excel/api-excel-excel-ipcr-get';
import { apiExcelExcelJobOrderForm1Get } from '../fn/excel/api-excel-excel-job-order-form-1-get';
import { ApiExcelExcelJobOrderForm1Get$Params } from '../fn/excel/api-excel-excel-job-order-form-1-get';
import { apiExcelExcelJobOrderForm2Get } from '../fn/excel/api-excel-excel-job-order-form-2-get';
import { ApiExcelExcelJobOrderForm2Get$Params } from '../fn/excel/api-excel-excel-job-order-form-2-get';
import { apiExcelExcelListOfAllocationCasualGet } from '../fn/excel/api-excel-excel-list-of-allocation-casual-get';
import { ApiExcelExcelListOfAllocationCasualGet$Params } from '../fn/excel/api-excel-excel-list-of-allocation-casual-get';
import { apiExcelExcelListOfAllocationGet } from '../fn/excel/api-excel-excel-list-of-allocation-get';
import { ApiExcelExcelListOfAllocationGet$Params } from '../fn/excel/api-excel-excel-list-of-allocation-get';
import { apiExcelExcelListOfVacantPositionsGet } from '../fn/excel/api-excel-excel-list-of-vacant-positions-get';
import { ApiExcelExcelListOfVacantPositionsGet$Params } from '../fn/excel/api-excel-excel-list-of-vacant-positions-get';
import { apiExcelExcelManpowerComplementGet } from '../fn/excel/api-excel-excel-manpower-complement-get';
import { ApiExcelExcelManpowerComplementGet$Params } from '../fn/excel/api-excel-excel-manpower-complement-get';
import { apiExcelExcelMonthlyAccessionGet } from '../fn/excel/api-excel-excel-monthly-accession-get';
import { ApiExcelExcelMonthlyAccessionGet$Params } from '../fn/excel/api-excel-excel-monthly-accession-get';
import { apiExcelExcelMonthlySeparationGet } from '../fn/excel/api-excel-excel-monthly-separation-get';
import { ApiExcelExcelMonthlySeparationGet$Params } from '../fn/excel/api-excel-excel-monthly-separation-get';
import { apiExcelExcelOfficesNoOfExistingPositionsGet } from '../fn/excel/api-excel-excel-offices-no-of-existing-positions-get';
import { ApiExcelExcelOfficesNoOfExistingPositionsGet$Params } from '../fn/excel/api-excel-excel-offices-no-of-existing-positions-get';
import { apiExcelExcelOpcrGet } from '../fn/excel/api-excel-excel-opcr-get';
import { ApiExcelExcelOpcrGet$Params } from '../fn/excel/api-excel-excel-opcr-get';
import { apiExcelExcelPayrollWorkedDaysGet } from '../fn/excel/api-excel-excel-payroll-worked-days-get';
import { ApiExcelExcelPayrollWorkedDaysGet$Params } from '../fn/excel/api-excel-excel-payroll-worked-days-get';
import { apiExcelExcelPdsGet } from '../fn/excel/api-excel-excel-pds-get';
import { ApiExcelExcelPdsGet$Params } from '../fn/excel/api-excel-excel-pds-get';
import { apiExcelExcelPendingFinalResultsGet } from '../fn/excel/api-excel-excel-pending-final-results-get';
import { ApiExcelExcelPendingFinalResultsGet$Params } from '../fn/excel/api-excel-excel-pending-final-results-get';
import { apiExcelExcelPlantillaCasualPersonnelGet } from '../fn/excel/api-excel-excel-plantilla-casual-personnel-get';
import { ApiExcelExcelPlantillaCasualPersonnelGet$Params } from '../fn/excel/api-excel-excel-plantilla-casual-personnel-get';
import { apiExcelExcelPlantillaofPersonnelGet } from '../fn/excel/api-excel-excel-plantillaof-personnel-get';
import { ApiExcelExcelPlantillaofPersonnelGet$Params } from '../fn/excel/api-excel-excel-plantillaof-personnel-get';
import { apiExcelExcelPsbSummaryGet } from '../fn/excel/api-excel-excel-psb-summary-get';
import { ApiExcelExcelPsbSummaryGet$Params } from '../fn/excel/api-excel-excel-psb-summary-get';
import { apiExcelExcelRankingPositionsGet } from '../fn/excel/api-excel-excel-ranking-positions-get';
import { ApiExcelExcelRankingPositionsGet$Params } from '../fn/excel/api-excel-excel-ranking-positions-get';
import { apiExcelExcelReportofAppointmentsGet } from '../fn/excel/api-excel-excel-reportof-appointments-get';
import { ApiExcelExcelReportofAppointmentsGet$Params } from '../fn/excel/api-excel-excel-reportof-appointments-get';
import { apiExcelExcelSavingsLedgerGet } from '../fn/excel/api-excel-excel-savings-ledger-get';
import { ApiExcelExcelSavingsLedgerGet$Params } from '../fn/excel/api-excel-excel-savings-ledger-get';
import { apiExcelExcelSingleBillingGet } from '../fn/excel/api-excel-excel-single-billing-get';
import { ApiExcelExcelSingleBillingGet$Params } from '../fn/excel/api-excel-excel-single-billing-get';
import { apiExcelExcelSingleBillingNoPositionGet } from '../fn/excel/api-excel-excel-single-billing-no-position-get';
import { ApiExcelExcelSingleBillingNoPositionGet$Params } from '../fn/excel/api-excel-excel-single-billing-no-position-get';
import { apiExcelExcelSomaPost } from '../fn/excel/api-excel-excel-soma-post';
import { ApiExcelExcelSomaPost$Params } from '../fn/excel/api-excel-excel-soma-post';
import { apiExcelExcelSubsidiaryGet } from '../fn/excel/api-excel-excel-subsidiary-get';
import { ApiExcelExcelSubsidiaryGet$Params } from '../fn/excel/api-excel-excel-subsidiary-get';
import { apiExcelExcelSummaryListOfIpcrGet } from '../fn/excel/api-excel-excel-summary-list-of-ipcr-get';
import { ApiExcelExcelSummaryListOfIpcrGet$Params } from '../fn/excel/api-excel-excel-summary-list-of-ipcr-get';
import { apiExcelExcelSummaryListOfIpcrRatingsGet } from '../fn/excel/api-excel-excel-summary-list-of-ipcr-ratings-get';
import { ApiExcelExcelSummaryListOfIpcrRatingsGet$Params } from '../fn/excel/api-excel-excel-summary-list-of-ipcr-ratings-get';
import { apiExcelExcelSummaryOfJobOrderGet } from '../fn/excel/api-excel-excel-summary-of-job-order-get';
import { ApiExcelExcelSummaryOfJobOrderGet$Params } from '../fn/excel/api-excel-excel-summary-of-job-order-get';
import { apiExcelExcelTemporaryAppointmentsGet } from '../fn/excel/api-excel-excel-temporary-appointments-get';
import { ApiExcelExcelTemporaryAppointmentsGet$Params } from '../fn/excel/api-excel-excel-temporary-appointments-get';
import { apiExcelExcelTopsheetReportGet } from '../fn/excel/api-excel-excel-topsheet-report-get';
import { ApiExcelExcelTopsheetReportGet$Params } from '../fn/excel/api-excel-excel-topsheet-report-get';
import { apiExcelExcelTransmittalGet } from '../fn/excel/api-excel-excel-transmittal-get';
import { ApiExcelExcelTransmittalGet$Params } from '../fn/excel/api-excel-excel-transmittal-get';
import { apiExcelExcelTrialBalanceGet } from '../fn/excel/api-excel-excel-trial-balance-get';
import { ApiExcelExcelTrialBalanceGet$Params } from '../fn/excel/api-excel-excel-trial-balance-get';
import { apiExcelExcelTrialBalanceMonthlyGet } from '../fn/excel/api-excel-excel-trial-balance-monthly-get';
import { ApiExcelExcelTrialBalanceMonthlyGet$Params } from '../fn/excel/api-excel-excel-trial-balance-monthly-get';
import { apiExcelExportBankAdvice2Get } from '../fn/excel/api-excel-export-bank-advice-2-get';
import { ApiExcelExportBankAdvice2Get$Params } from '../fn/excel/api-excel-export-bank-advice-2-get';
import { apiExcelExportBankAdviceGet } from '../fn/excel/api-excel-export-bank-advice-get';
import { ApiExcelExportBankAdviceGet$Params } from '../fn/excel/api-excel-export-bank-advice-get';
import { apiExcelExportServiceRecordsGet } from '../fn/excel/api-excel-export-service-records-get';
import { ApiExcelExportServiceRecordsGet$Params } from '../fn/excel/api-excel-export-service-records-get';
import { apiExcelExportVacantPositionsGet } from '../fn/excel/api-excel-export-vacant-positions-get';
import { ApiExcelExportVacantPositionsGet$Params } from '../fn/excel/api-excel-export-vacant-positions-get';
import { apiExcelExportXlsx2Get } from '../fn/excel/api-excel-export-xlsx-2-get';
import { ApiExcelExportXlsx2Get$Params } from '../fn/excel/api-excel-export-xlsx-2-get';
import { apiExcelExportXlsxGet } from '../fn/excel/api-excel-export-xlsx-get';
import { ApiExcelExportXlsxGet$Params } from '../fn/excel/api-excel-export-xlsx-get';
import { apiExcelJournalVoucherGet } from '../fn/excel/api-excel-journal-voucher-get';
import { ApiExcelJournalVoucherGet$Params } from '../fn/excel/api-excel-journal-voucher-get';
import { apiExcelPayoutTemplatePost } from '../fn/excel/api-excel-payout-template-post';
import { ApiExcelPayoutTemplatePost$Params } from '../fn/excel/api-excel-payout-template-post';
import { apiExcelPdfSomaGet } from '../fn/excel/api-excel-pdf-soma-get';
import { ApiExcelPdfSomaGet$Params } from '../fn/excel/api-excel-pdf-soma-get';
import { apiExcelPdsImportPost$Json } from '../fn/excel/api-excel-pds-import-post-json';
import { ApiExcelPdsImportPost$Json$Params } from '../fn/excel/api-excel-pds-import-post-json';
import { apiExcelPdsImportPost$Plain } from '../fn/excel/api-excel-pds-import-post-plain';
import { ApiExcelPdsImportPost$Plain$Params } from '../fn/excel/api-excel-pds-import-post-plain';
import { apiExcelTopsheetTemplatePost } from '../fn/excel/api-excel-topsheet-template-post';
import { ApiExcelTopsheetTemplatePost$Params } from '../fn/excel/api-excel-topsheet-template-post';
import { Entity } from '../models/entity';

@Injectable({ providedIn: 'root' })
export class ExcelService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiExcelExportBankAdviceGet()` */
  static readonly ApiExcelExportBankAdviceGetPath = '/api/Excel/ExportBankAdvice';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExportBankAdviceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportBankAdviceGet$Response(params?: ApiExcelExportBankAdviceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExportBankAdviceGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExportBankAdviceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportBankAdviceGet(params?: ApiExcelExportBankAdviceGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExportBankAdviceGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExportBankAdvice2Get()` */
  static readonly ApiExcelExportBankAdvice2GetPath = '/api/Excel/ExportBankAdvice2';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExportBankAdvice2Get()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportBankAdvice2Get$Response(params?: ApiExcelExportBankAdvice2Get$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExportBankAdvice2Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExportBankAdvice2Get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportBankAdvice2Get(params?: ApiExcelExportBankAdvice2Get$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExportBankAdvice2Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelGmdGet()` */
  static readonly ApiExcelExcelGmdGetPath = '/api/Excel/Excel_GMD';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelGmdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelGmdGet$Response(params?: ApiExcelExcelGmdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelGmdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelGmdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelGmdGet(params?: ApiExcelExcelGmdGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelGmdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelGmd2Get()` */
  static readonly ApiExcelExcelGmd2GetPath = '/api/Excel/Excel_GMD2';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelGmd2Get()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelGmd2Get$Response(params?: ApiExcelExcelGmd2Get$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelGmd2Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelGmd2Get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelGmd2Get(params?: ApiExcelExcelGmd2Get$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelGmd2Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelSingleBillingGet()` */
  static readonly ApiExcelExcelSingleBillingGetPath = '/api/Excel/Excel_SingleBilling';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelSingleBillingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSingleBillingGet$Response(params?: ApiExcelExcelSingleBillingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelSingleBillingGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelSingleBillingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSingleBillingGet(params?: ApiExcelExcelSingleBillingGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelSingleBillingGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelBillingGet()` */
  static readonly ApiExcelExcelBillingGetPath = '/api/Excel/Excel_Billing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelBillingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingGet$Response(params?: ApiExcelExcelBillingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelBillingGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelBillingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingGet(params?: ApiExcelExcelBillingGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelBillingGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelBillingNoPositionGet()` */
  static readonly ApiExcelExcelBillingNoPositionGetPath = '/api/Excel/Excel_BillingNoPosition';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelBillingNoPositionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingNoPositionGet$Response(params?: ApiExcelExcelBillingNoPositionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelBillingNoPositionGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelBillingNoPositionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingNoPositionGet(params?: ApiExcelExcelBillingNoPositionGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelBillingNoPositionGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelBillingCnxGet()` */
  static readonly ApiExcelExcelBillingCnxGetPath = '/api/Excel/Excel_BillingCNX';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelBillingCnxGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingCnxGet$Response(params?: ApiExcelExcelBillingCnxGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelBillingCnxGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelBillingCnxGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingCnxGet(params?: ApiExcelExcelBillingCnxGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelBillingCnxGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelSingleBillingNoPositionGet()` */
  static readonly ApiExcelExcelSingleBillingNoPositionGetPath = '/api/Excel/Excel_SingleBillingNoPosition';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelSingleBillingNoPositionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSingleBillingNoPositionGet$Response(params?: ApiExcelExcelSingleBillingNoPositionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelSingleBillingNoPositionGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelSingleBillingNoPositionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSingleBillingNoPositionGet(params?: ApiExcelExcelSingleBillingNoPositionGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelSingleBillingNoPositionGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelExportDisbursementAdviceGet()` */
  static readonly ApiExcelExcelExportDisbursementAdviceGetPath = '/api/Excel/ExcelExport_DisbursementAdvice';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelExportDisbursementAdviceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportDisbursementAdviceGet$Response(params?: ApiExcelExcelExportDisbursementAdviceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelExportDisbursementAdviceGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelExportDisbursementAdviceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportDisbursementAdviceGet(params?: ApiExcelExcelExportDisbursementAdviceGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelExportDisbursementAdviceGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelExportSingleDeductionReportGet()` */
  static readonly ApiExcelExcelExportSingleDeductionReportGetPath = '/api/Excel/ExcelExport_SingleDeductionReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelExportSingleDeductionReportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportSingleDeductionReportGet$Response(params?: ApiExcelExcelExportSingleDeductionReportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelExportSingleDeductionReportGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelExportSingleDeductionReportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportSingleDeductionReportGet(params?: ApiExcelExcelExportSingleDeductionReportGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelExportSingleDeductionReportGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExportXlsx2Get()` */
  static readonly ApiExcelExportXlsx2GetPath = '/api/Excel/ExportXlsx2';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExportXlsx2Get()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportXlsx2Get$Response(params?: ApiExcelExportXlsx2Get$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExportXlsx2Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExportXlsx2Get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportXlsx2Get(params?: ApiExcelExportXlsx2Get$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExportXlsx2Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExportXlsxGet()` */
  static readonly ApiExcelExportXlsxGetPath = '/api/Excel/ExportXlsx';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExportXlsxGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportXlsxGet$Response(params?: ApiExcelExportXlsxGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExportXlsxGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExportXlsxGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportXlsxGet(params?: ApiExcelExportXlsxGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExportXlsxGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelPayoutTemplatePost()` */
  static readonly ApiExcelPayoutTemplatePostPath = '/api/Excel/PayoutTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelPayoutTemplatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelPayoutTemplatePost$Response(params?: ApiExcelPayoutTemplatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelPayoutTemplatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelPayoutTemplatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelPayoutTemplatePost(params?: ApiExcelPayoutTemplatePost$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelPayoutTemplatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelTopsheetTemplatePost()` */
  static readonly ApiExcelTopsheetTemplatePostPath = '/api/Excel/TopsheetTemplate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelTopsheetTemplatePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelTopsheetTemplatePost$Response(params?: ApiExcelTopsheetTemplatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelTopsheetTemplatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelTopsheetTemplatePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelTopsheetTemplatePost(params?: ApiExcelTopsheetTemplatePost$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelTopsheetTemplatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelCheckVoucherGet()` */
  static readonly ApiExcelCheckVoucherGetPath = '/api/Excel/CheckVoucher';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelCheckVoucherGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelCheckVoucherGet$Response(params?: ApiExcelCheckVoucherGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelCheckVoucherGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelCheckVoucherGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelCheckVoucherGet(params?: ApiExcelCheckVoucherGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelCheckVoucherGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelJournalVoucherGet()` */
  static readonly ApiExcelJournalVoucherGetPath = '/api/Excel/JournalVoucher';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelJournalVoucherGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelJournalVoucherGet$Response(params?: ApiExcelJournalVoucherGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelJournalVoucherGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelJournalVoucherGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelJournalVoucherGet(params?: ApiExcelJournalVoucherGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelJournalVoucherGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelGenJournalGet()` */
  static readonly ApiExcelExcelGenJournalGetPath = '/api/Excel/Excel_GenJournal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelGenJournalGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelGenJournalGet$Response(params?: ApiExcelExcelGenJournalGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelGenJournalGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelGenJournalGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelGenJournalGet(params?: ApiExcelExcelGenJournalGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelGenJournalGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelSubsidiaryGet()` */
  static readonly ApiExcelExcelSubsidiaryGetPath = '/api/Excel/Excel_Subsidiary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelSubsidiaryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSubsidiaryGet$Response(params?: ApiExcelExcelSubsidiaryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelSubsidiaryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelSubsidiaryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSubsidiaryGet(params?: ApiExcelExcelSubsidiaryGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelSubsidiaryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelTrialBalanceGet()` */
  static readonly ApiExcelExcelTrialBalanceGetPath = '/api/Excel/Excel_TrialBalance';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelTrialBalanceGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTrialBalanceGet$Response(params?: ApiExcelExcelTrialBalanceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelTrialBalanceGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelTrialBalanceGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTrialBalanceGet(params?: ApiExcelExcelTrialBalanceGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelTrialBalanceGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelTrialBalanceMonthlyGet()` */
  static readonly ApiExcelExcelTrialBalanceMonthlyGetPath = '/api/Excel/Excel_TrialBalanceMonthly';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelTrialBalanceMonthlyGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTrialBalanceMonthlyGet$Response(params?: ApiExcelExcelTrialBalanceMonthlyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelTrialBalanceMonthlyGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelTrialBalanceMonthlyGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTrialBalanceMonthlyGet(params?: ApiExcelExcelTrialBalanceMonthlyGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelTrialBalanceMonthlyGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelCashReceiptRegisterGet()` */
  static readonly ApiExcelExcelCashReceiptRegisterGetPath = '/api/Excel/Excel_CashReceiptRegister';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelCashReceiptRegisterGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCashReceiptRegisterGet$Response(params?: ApiExcelExcelCashReceiptRegisterGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelCashReceiptRegisterGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelCashReceiptRegisterGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCashReceiptRegisterGet(params?: ApiExcelExcelCashReceiptRegisterGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelCashReceiptRegisterGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelBillingRegisterGet()` */
  static readonly ApiExcelExcelBillingRegisterGetPath = '/api/Excel/Excel_BillingRegister';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelBillingRegisterGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingRegisterGet$Response(params?: ApiExcelExcelBillingRegisterGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelBillingRegisterGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelBillingRegisterGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelBillingRegisterGet(params?: ApiExcelExcelBillingRegisterGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelBillingRegisterGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelCheckDisbursementsGet()` */
  static readonly ApiExcelExcelCheckDisbursementsGetPath = '/api/Excel/Excel_CheckDisbursements';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelCheckDisbursementsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCheckDisbursementsGet$Response(params?: ApiExcelExcelCheckDisbursementsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelCheckDisbursementsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelCheckDisbursementsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCheckDisbursementsGet(params?: ApiExcelExcelCheckDisbursementsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelCheckDisbursementsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelCheckRegisterGet()` */
  static readonly ApiExcelExcelCheckRegisterGetPath = '/api/Excel/Excel_CheckRegister';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelCheckRegisterGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCheckRegisterGet$Response(params?: ApiExcelExcelCheckRegisterGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelCheckRegisterGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelCheckRegisterGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCheckRegisterGet(params?: ApiExcelExcelCheckRegisterGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelCheckRegisterGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelExportDeductionsGet()` */
  static readonly ApiExcelExcelExportDeductionsGetPath = '/api/Excel/ExcelExport_Deductions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelExportDeductionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportDeductionsGet$Response(params?: ApiExcelExcelExportDeductionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelExportDeductionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelExportDeductionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportDeductionsGet(params?: ApiExcelExcelExportDeductionsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelExportDeductionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelExportDeductionsByClientGet()` */
  static readonly ApiExcelExcelExportDeductionsByClientGetPath = '/api/Excel/ExcelExport_DeductionsByClient';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelExportDeductionsByClientGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportDeductionsByClientGet$Response(params?: ApiExcelExcelExportDeductionsByClientGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelExportDeductionsByClientGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelExportDeductionsByClientGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportDeductionsByClientGet(params?: ApiExcelExcelExportDeductionsByClientGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelExportDeductionsByClientGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelExportSavingsMasterfileGet()` */
  static readonly ApiExcelExcelExportSavingsMasterfileGetPath = '/api/Excel/ExcelExport_SavingsMasterfile';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelExportSavingsMasterfileGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportSavingsMasterfileGet$Response(params?: ApiExcelExcelExportSavingsMasterfileGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelExportSavingsMasterfileGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelExportSavingsMasterfileGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportSavingsMasterfileGet(params?: ApiExcelExcelExportSavingsMasterfileGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelExportSavingsMasterfileGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelExportMembersGet()` */
  static readonly ApiExcelExcelExportMembersGetPath = '/api/Excel/ExcelExport_Members';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelExportMembersGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportMembersGet$Response(params?: ApiExcelExcelExportMembersGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelExportMembersGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelExportMembersGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelExportMembersGet(params?: ApiExcelExcelExportMembersGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelExportMembersGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelSavingsLedgerGet()` */
  static readonly ApiExcelExcelSavingsLedgerGetPath = '/api/Excel/Excel_SavingsLedger';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelSavingsLedgerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSavingsLedgerGet$Response(params?: ApiExcelExcelSavingsLedgerGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelSavingsLedgerGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelSavingsLedgerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSavingsLedgerGet(params?: ApiExcelExcelSavingsLedgerGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelSavingsLedgerGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelCoopShareLedgerGet()` */
  static readonly ApiExcelExcelCoopShareLedgerGetPath = '/api/Excel/Excel_CoopShareLedger';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelCoopShareLedgerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCoopShareLedgerGet$Response(params?: ApiExcelExcelCoopShareLedgerGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelCoopShareLedgerGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelCoopShareLedgerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelCoopShareLedgerGet(params?: ApiExcelExcelCoopShareLedgerGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelCoopShareLedgerGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelTopsheetReportGet()` */
  static readonly ApiExcelExcelTopsheetReportGetPath = '/api/Excel/Excel_TopsheetReport';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelTopsheetReportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTopsheetReportGet$Response(params?: ApiExcelExcelTopsheetReportGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelTopsheetReportGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelTopsheetReportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTopsheetReportGet(params?: ApiExcelExcelTopsheetReportGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelTopsheetReportGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelDeductionsLedgerGet()` */
  static readonly ApiExcelExcelDeductionsLedgerGetPath = '/api/Excel/Excel_DeductionsLedger';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelDeductionsLedgerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelDeductionsLedgerGet$Response(params?: ApiExcelExcelDeductionsLedgerGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelDeductionsLedgerGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelDeductionsLedgerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelDeductionsLedgerGet(params?: ApiExcelExcelDeductionsLedgerGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelDeductionsLedgerGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelPayrollWorkedDaysGet()` */
  static readonly ApiExcelExcelPayrollWorkedDaysGetPath = '/api/Excel/Excel_PayrollWorkedDays';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelPayrollWorkedDaysGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelPayrollWorkedDaysGet$Response(params?: ApiExcelExcelPayrollWorkedDaysGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelPayrollWorkedDaysGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelPayrollWorkedDaysGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelPayrollWorkedDaysGet(params?: ApiExcelExcelPayrollWorkedDaysGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelPayrollWorkedDaysGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelSomaPost()` */
  static readonly ApiExcelExcelSomaPostPath = '/api/Excel/Excel_SOMA';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelSomaPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelExcelSomaPost$Response(params?: ApiExcelExcelSomaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelSomaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelSomaPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiExcelExcelSomaPost(params?: ApiExcelExcelSomaPost$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelSomaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelPdfSomaGet()` */
  static readonly ApiExcelPdfSomaGetPath = '/api/Excel/PDF_SOMA';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelPdfSomaGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelPdfSomaGet$Response(params?: ApiExcelPdfSomaGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelPdfSomaGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelPdfSomaGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelPdfSomaGet(params?: ApiExcelPdfSomaGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelPdfSomaGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelPdsImportPost()` */
  static readonly ApiExcelPdsImportPostPath = '/api/Excel/PDS_Import';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelPdsImportPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelPdsImportPost$Plain$Response(params?: ApiExcelPdsImportPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Entity>> {
    return apiExcelPdsImportPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelPdsImportPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelPdsImportPost$Plain(params?: ApiExcelPdsImportPost$Plain$Params, context?: HttpContext): Observable<Entity> {
    return this.apiExcelPdsImportPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Entity>): Entity => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelPdsImportPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelPdsImportPost$Json$Response(params?: ApiExcelPdsImportPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Entity>> {
    return apiExcelPdsImportPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelPdsImportPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelPdsImportPost$Json(params?: ApiExcelPdsImportPost$Json$Params, context?: HttpContext): Observable<Entity> {
    return this.apiExcelPdsImportPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Entity>): Entity => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelPdsGet()` */
  static readonly ApiExcelExcelPdsGetPath = '/api/Excel/Excel_PDS';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelPdsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelPdsGet$Response(params?: ApiExcelExcelPdsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelPdsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelPdsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelPdsGet(params?: ApiExcelExcelPdsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelPdsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelFormAGet()` */
  static readonly ApiExcelExcelFormAGetPath = '/api/Excel/Excel_FormA';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelFormAGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelFormAGet$Response(params?: ApiExcelExcelFormAGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelFormAGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelFormAGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelFormAGet(params?: ApiExcelExcelFormAGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelFormAGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelFormBGet()` */
  static readonly ApiExcelExcelFormBGetPath = '/api/Excel/Excel_FormB';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelFormBGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelFormBGet$Response(params?: ApiExcelExcelFormBGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelFormBGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelFormBGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelFormBGet(params?: ApiExcelExcelFormBGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelFormBGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelFormCfGet()` */
  static readonly ApiExcelExcelFormCfGetPath = '/api/Excel/Excel_FormCF';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelFormCfGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelFormCfGet$Response(params?: ApiExcelExcelFormCfGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelFormCfGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelFormCfGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelFormCfGet(params?: ApiExcelExcelFormCfGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelFormCfGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExportVacantPositionsGet()` */
  static readonly ApiExcelExportVacantPositionsGetPath = '/api/Excel/ExportVacantPositions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExportVacantPositionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportVacantPositionsGet$Response(params?: ApiExcelExportVacantPositionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExportVacantPositionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExportVacantPositionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportVacantPositionsGet(params?: ApiExcelExportVacantPositionsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExportVacantPositionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelFormDGet()` */
  static readonly ApiExcelExcelFormDGetPath = '/api/Excel/Excel_FormD';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelFormDGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelFormDGet$Response(params?: ApiExcelExcelFormDGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelFormDGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelFormDGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelFormDGet(params?: ApiExcelExcelFormDGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelFormDGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelFormEGet()` */
  static readonly ApiExcelExcelFormEGetPath = '/api/Excel/Excel_FormE';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelFormEGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelFormEGet$Response(params?: ApiExcelExcelFormEGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelFormEGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelFormEGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelFormEGet(params?: ApiExcelExcelFormEGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelFormEGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelPlantillaofPersonnelGet()` */
  static readonly ApiExcelExcelPlantillaofPersonnelGetPath = '/api/Excel/Excel_PlantillaofPersonnel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelPlantillaofPersonnelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelPlantillaofPersonnelGet$Response(params?: ApiExcelExcelPlantillaofPersonnelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelPlantillaofPersonnelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelPlantillaofPersonnelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelPlantillaofPersonnelGet(params?: ApiExcelExcelPlantillaofPersonnelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelPlantillaofPersonnelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelTransmittalGet()` */
  static readonly ApiExcelExcelTransmittalGetPath = '/api/Excel/Excel_Transmittal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelTransmittalGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTransmittalGet$Response(params?: ApiExcelExcelTransmittalGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelTransmittalGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelTransmittalGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTransmittalGet(params?: ApiExcelExcelTransmittalGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelTransmittalGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelTemporaryAppointmentsGet()` */
  static readonly ApiExcelExcelTemporaryAppointmentsGetPath = '/api/Excel/Excel_TemporaryAppointments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelTemporaryAppointmentsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTemporaryAppointmentsGet$Response(params?: ApiExcelExcelTemporaryAppointmentsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelTemporaryAppointmentsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelTemporaryAppointmentsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelTemporaryAppointmentsGet(params?: ApiExcelExcelTemporaryAppointmentsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelTemporaryAppointmentsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelJobOrderForm1Get()` */
  static readonly ApiExcelExcelJobOrderForm1GetPath = '/api/Excel/Excel_JobOrderForm1';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelJobOrderForm1Get()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelJobOrderForm1Get$Response(params?: ApiExcelExcelJobOrderForm1Get$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelJobOrderForm1Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelJobOrderForm1Get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelJobOrderForm1Get(params?: ApiExcelExcelJobOrderForm1Get$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelJobOrderForm1Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelJobOrderForm2Get()` */
  static readonly ApiExcelExcelJobOrderForm2GetPath = '/api/Excel/Excel_JobOrderForm2';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelJobOrderForm2Get()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelJobOrderForm2Get$Response(params?: ApiExcelExcelJobOrderForm2Get$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelJobOrderForm2Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelJobOrderForm2Get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelJobOrderForm2Get(params?: ApiExcelExcelJobOrderForm2Get$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelJobOrderForm2Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelListOfVacantPositionsGet()` */
  static readonly ApiExcelExcelListOfVacantPositionsGetPath = '/api/Excel/Excel_ListOfVacantPositions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelListOfVacantPositionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelListOfVacantPositionsGet$Response(params?: ApiExcelExcelListOfVacantPositionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelListOfVacantPositionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelListOfVacantPositionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelListOfVacantPositionsGet(params?: ApiExcelExcelListOfVacantPositionsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelListOfVacantPositionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelEmployeesProfileForm1Get()` */
  static readonly ApiExcelExcelEmployeesProfileForm1GetPath = '/api/Excel/Excel_EmployeesProfileForm1';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelEmployeesProfileForm1Get()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelEmployeesProfileForm1Get$Response(params?: ApiExcelExcelEmployeesProfileForm1Get$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelEmployeesProfileForm1Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelEmployeesProfileForm1Get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelEmployeesProfileForm1Get(params?: ApiExcelExcelEmployeesProfileForm1Get$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelEmployeesProfileForm1Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelEmployeesProfileForm2Get()` */
  static readonly ApiExcelExcelEmployeesProfileForm2GetPath = '/api/Excel/Excel_EmployeesProfileForm2';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelEmployeesProfileForm2Get()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelEmployeesProfileForm2Get$Response(params?: ApiExcelExcelEmployeesProfileForm2Get$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelEmployeesProfileForm2Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelEmployeesProfileForm2Get$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelEmployeesProfileForm2Get(params?: ApiExcelExcelEmployeesProfileForm2Get$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelEmployeesProfileForm2Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelEvaluationFormGet()` */
  static readonly ApiExcelExcelEvaluationFormGetPath = '/api/Excel/Excel_EvaluationForm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelEvaluationFormGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelEvaluationFormGet$Response(params?: ApiExcelExcelEvaluationFormGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelEvaluationFormGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelEvaluationFormGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelEvaluationFormGet(params?: ApiExcelExcelEvaluationFormGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelEvaluationFormGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelMonthlyAccessionGet()` */
  static readonly ApiExcelExcelMonthlyAccessionGetPath = '/api/Excel/Excel_MonthlyAccession';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelMonthlyAccessionGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelMonthlyAccessionGet$Response(params?: ApiExcelExcelMonthlyAccessionGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelMonthlyAccessionGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelMonthlyAccessionGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelMonthlyAccessionGet(params?: ApiExcelExcelMonthlyAccessionGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelMonthlyAccessionGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelMonthlySeparationGet()` */
  static readonly ApiExcelExcelMonthlySeparationGetPath = '/api/Excel/Excel_MonthlySeparation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelMonthlySeparationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelMonthlySeparationGet$Response(params?: ApiExcelExcelMonthlySeparationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelMonthlySeparationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelMonthlySeparationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelMonthlySeparationGet(params?: ApiExcelExcelMonthlySeparationGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelMonthlySeparationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelManpowerComplementGet()` */
  static readonly ApiExcelExcelManpowerComplementGetPath = '/api/Excel/Excel_ManpowerComplement';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelManpowerComplementGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelManpowerComplementGet$Response(params?: ApiExcelExcelManpowerComplementGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelManpowerComplementGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelManpowerComplementGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelManpowerComplementGet(params?: ApiExcelExcelManpowerComplementGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelManpowerComplementGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelRankingPositionsGet()` */
  static readonly ApiExcelExcelRankingPositionsGetPath = '/api/Excel/Excel_RankingPositions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelRankingPositionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelRankingPositionsGet$Response(params?: ApiExcelExcelRankingPositionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelRankingPositionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelRankingPositionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelRankingPositionsGet(params?: ApiExcelExcelRankingPositionsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelRankingPositionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelPlantillaCasualPersonnelGet()` */
  static readonly ApiExcelExcelPlantillaCasualPersonnelGetPath = '/api/Excel/Excel_PlantillaCasualPersonnel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelPlantillaCasualPersonnelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelPlantillaCasualPersonnelGet$Response(params?: ApiExcelExcelPlantillaCasualPersonnelGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelPlantillaCasualPersonnelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelPlantillaCasualPersonnelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelPlantillaCasualPersonnelGet(params?: ApiExcelExcelPlantillaCasualPersonnelGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelPlantillaCasualPersonnelGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelReportofAppointmentsGet()` */
  static readonly ApiExcelExcelReportofAppointmentsGetPath = '/api/Excel/Excel_ReportofAppointments';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelReportofAppointmentsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelReportofAppointmentsGet$Response(params?: ApiExcelExcelReportofAppointmentsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelReportofAppointmentsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelReportofAppointmentsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelReportofAppointmentsGet(params?: ApiExcelExcelReportofAppointmentsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelReportofAppointmentsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelSummaryOfJobOrderGet()` */
  static readonly ApiExcelExcelSummaryOfJobOrderGetPath = '/api/Excel/Excel_SummaryOfJobOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelSummaryOfJobOrderGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSummaryOfJobOrderGet$Response(params?: ApiExcelExcelSummaryOfJobOrderGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelSummaryOfJobOrderGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelSummaryOfJobOrderGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSummaryOfJobOrderGet(params?: ApiExcelExcelSummaryOfJobOrderGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelSummaryOfJobOrderGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelOfficesNoOfExistingPositionsGet()` */
  static readonly ApiExcelExcelOfficesNoOfExistingPositionsGetPath = '/api/Excel/Excel_OfficesNoOfExistingPositions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelOfficesNoOfExistingPositionsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelOfficesNoOfExistingPositionsGet$Response(params?: ApiExcelExcelOfficesNoOfExistingPositionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelOfficesNoOfExistingPositionsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelOfficesNoOfExistingPositionsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelOfficesNoOfExistingPositionsGet(params?: ApiExcelExcelOfficesNoOfExistingPositionsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelOfficesNoOfExistingPositionsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelSummaryListOfIpcrGet()` */
  static readonly ApiExcelExcelSummaryListOfIpcrGetPath = '/api/Excel/Excel_SummaryListOfIPCR';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelSummaryListOfIpcrGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSummaryListOfIpcrGet$Response(params?: ApiExcelExcelSummaryListOfIpcrGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelSummaryListOfIpcrGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelSummaryListOfIpcrGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSummaryListOfIpcrGet(params?: ApiExcelExcelSummaryListOfIpcrGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelSummaryListOfIpcrGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelSummaryListOfIpcrRatingsGet()` */
  static readonly ApiExcelExcelSummaryListOfIpcrRatingsGetPath = '/api/Excel/Excel_SummaryListOfIPCRRatings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelSummaryListOfIpcrRatingsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSummaryListOfIpcrRatingsGet$Response(params?: ApiExcelExcelSummaryListOfIpcrRatingsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelSummaryListOfIpcrRatingsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelSummaryListOfIpcrRatingsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelSummaryListOfIpcrRatingsGet(params?: ApiExcelExcelSummaryListOfIpcrRatingsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelSummaryListOfIpcrRatingsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelIpcrGet()` */
  static readonly ApiExcelExcelIpcrGetPath = '/api/Excel/Excel_IPCR';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelIpcrGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelIpcrGet$Response(params?: ApiExcelExcelIpcrGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelIpcrGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelIpcrGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelIpcrGet(params?: ApiExcelExcelIpcrGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelIpcrGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelOpcrGet()` */
  static readonly ApiExcelExcelOpcrGetPath = '/api/Excel/Excel_OPCR';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelOpcrGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelOpcrGet$Response(params?: ApiExcelExcelOpcrGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelOpcrGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelOpcrGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelOpcrGet(params?: ApiExcelExcelOpcrGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelOpcrGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelListOfAllocationGet()` */
  static readonly ApiExcelExcelListOfAllocationGetPath = '/api/Excel/Excel_ListOfAllocation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelListOfAllocationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelListOfAllocationGet$Response(params?: ApiExcelExcelListOfAllocationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelListOfAllocationGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelListOfAllocationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelListOfAllocationGet(params?: ApiExcelExcelListOfAllocationGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelListOfAllocationGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelListOfAllocationCasualGet()` */
  static readonly ApiExcelExcelListOfAllocationCasualGetPath = '/api/Excel/Excel_ListOfAllocationCasual';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelListOfAllocationCasualGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelListOfAllocationCasualGet$Response(params?: ApiExcelExcelListOfAllocationCasualGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelListOfAllocationCasualGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelListOfAllocationCasualGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelListOfAllocationCasualGet(params?: ApiExcelExcelListOfAllocationCasualGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelListOfAllocationCasualGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExportServiceRecordsGet()` */
  static readonly ApiExcelExportServiceRecordsGetPath = '/api/Excel/Export_ServiceRecords';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExportServiceRecordsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportServiceRecordsGet$Response(params?: ApiExcelExportServiceRecordsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExportServiceRecordsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExportServiceRecordsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExportServiceRecordsGet(params?: ApiExcelExportServiceRecordsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExportServiceRecordsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelImportSalaryTablePost()` */
  static readonly ApiExcelExcelImportSalaryTablePostPath = '/api/Excel/Excel_ImportSalaryTable';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelImportSalaryTablePost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelExcelImportSalaryTablePost$Plain$Response(params?: ApiExcelExcelImportSalaryTablePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelImportSalaryTablePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelImportSalaryTablePost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelExcelImportSalaryTablePost$Plain(params?: ApiExcelExcelImportSalaryTablePost$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelImportSalaryTablePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelImportSalaryTablePost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelExcelImportSalaryTablePost$Json$Response(params?: ApiExcelExcelImportSalaryTablePost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelImportSalaryTablePost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelImportSalaryTablePost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelExcelImportSalaryTablePost$Json(params?: ApiExcelExcelImportSalaryTablePost$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelImportSalaryTablePost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelApplicantPoolGet()` */
  static readonly ApiExcelExcelApplicantPoolGetPath = '/api/Excel/Excel_ApplicantPool';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelApplicantPoolGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelApplicantPoolGet$Response(params?: ApiExcelExcelApplicantPoolGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelApplicantPoolGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelApplicantPoolGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelApplicantPoolGet(params?: ApiExcelExcelApplicantPoolGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelApplicantPoolGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelPsbSummaryGet()` */
  static readonly ApiExcelExcelPsbSummaryGetPath = '/api/Excel/Excel_PSBSummary';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelPsbSummaryGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelPsbSummaryGet$Response(params?: ApiExcelExcelPsbSummaryGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelPsbSummaryGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelPsbSummaryGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelPsbSummaryGet(params?: ApiExcelExcelPsbSummaryGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelPsbSummaryGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiExcelExcelPendingFinalResultsGet()` */
  static readonly ApiExcelExcelPendingFinalResultsGetPath = '/api/Excel/Excel_PendingFinalResults';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelExcelPendingFinalResultsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelPendingFinalResultsGet$Response(params?: ApiExcelExcelPendingFinalResultsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiExcelExcelPendingFinalResultsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiExcelExcelPendingFinalResultsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiExcelExcelPendingFinalResultsGet(params?: ApiExcelExcelPendingFinalResultsGet$Params, context?: HttpContext): Observable<Blob> {
    return this.apiExcelExcelPendingFinalResultsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
